export enum ETADeliveryMethodType {
  JiffyDelivery = 'JIFFY_DELIVERY',
  ClickAndCollect = 'CLICK_AND_COLLECT',
}
